import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { BreedrLogo } from "@/components/BreedrLogo";
import { type FileRoutesByFullPath } from "@/routeTree.gen";

const fallback: keyof FileRoutesByFullPath = "/bookings";

export const Route = createFileRoute("/(unauthed)/_layout")({
  validateSearch: z.object({
    redirect: z.string().optional().catch(fallback),
  }),
  beforeLoad: ({ context, search }) => {
    if (context.auth?.isAuthenticated) {
      redirect({
        to: search.redirect || fallback,
        throw: true,
      });

      return;
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex min-h-screen flex-col md:flex-row">
      <aside className="flex w-full items-center justify-center bg-breedr-blue-700 p-4 pt-12 md:w-1/2 md:items-stretch md:justify-start md:p-8">
        <BreedrLogo variant="default" size="sm" className="md:h-12" />
      </aside>
      <main className="flex flex-1 items-center justify-center bg-slate-50 p-8 md:w-1/2 md:p-16">
        <Outlet />
      </main>
    </div>
  );
}
